<app-sub-header 
[header]="'Completed Applications'"
[currentStage]="-1"
[totalStage]=""
></app-sub-header>




<section class="main-container main-container-sidenav">
  <div class="container container-super completed-opportunity">
    <!-- <h2 class="heading-title text-center">Completed Applications</h2> -->

    <div class="box box-super" *ngIf="dataSourceTable.length > 0 ">
      <div class="box-label">
        <h4>Total({{dataSourceTable.length}})</h4>
      </div>

      <div class="table-super">

        <table mat-table [dataSource]="dataSourceTable" class="simple-table">
  
          <!-- type Column -->
          <!-- <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef> Type </th>
            <td mat-cell *matCellDef="let element"> {{element.type}} </td>
          </ng-container> -->
  
          <!-- name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Application Name </th>
            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
          </ng-container>
  
          <!-- amount Column -->
          <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef> Amount </th>
            <td mat-cell *matCellDef="let element"> {{element.amount}} </td>
          </ng-container>
  
          <!-- date Column -->
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef> Last Update </th>
            <td mat-cell *matCellDef="let element"> {{element.date}} </td>
          </ng-container>
  
          <!-- status Column -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef> Status </th>
            <td mat-cell *matCellDef="let element"> {{element.status}} </td>
          </ng-container>
  
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </div>

   
      <div class="box" *ngIf="noOpportunity">
        <h2 class="text-center not-completed">Currently, there is no completed application.</h2>
      </div>
  
      <div class="button-footer margin-top2">

        <button type="button" class="mat-stepper-next resume-app"  (click)="onBack()">Resume Application</button>
    </div>

    

  </div>

</section>
